/**
 * Internal dependencies
 */
import {
    CURRENT_WEB_RECEIVE,
    CURRENT_WEB_REQUEST,
    CURRENT_WEB_REQUEST_SUCCESS,
    CURRENT_WEB_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentWeb, requestingCurrentWeb} from 'state/current-web/selectors';

/**
 * [description]
 *
 * @param  {[type]} web [description]
 * @return {[type]}         [description]
 */
export const setCurrentWeb = (web) => {
    return {
        type: CURRENT_WEB_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentWeb = () => (dispatch) => {
    dispatch({
        type: CURRENT_WEB_REQUEST,
    });

    return cscom
        .currentWeb()
        .get()
        .then((web) => {
            dispatch({
                type: CURRENT_WEB_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_WEB_RECEIVE,
                payload: {
                    web,
                },
            });
            return web;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_WEB_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_WEB_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentWebIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const currentWeb = getCurrentWeb(getState());
	const requesting = requestingCurrentWeb(getState());

	if (!currentWeb && requesting == false) {
		return dispatch(requestCurrentWeb(...props))
	}

	return currentWeb;
}
